import {api} from '../api';
import {reviewedApplicationError} from './state-contract';

/** Bounds waiting (including authentication). Retry must retain the mutation key. */
export async function saveRequest<T>(path:string,init:RequestInit):Promise<T>{
 const controller=new AbortController();let timer:ReturnType<typeof setTimeout>|undefined;
 try{return await Promise.race([api<T>(path,{...init,signal:controller.signal}),new Promise<never>((_,reject)=>{
  timer=setTimeout(()=>{controller.abort();reject(reviewedApplicationError('The save confirmation is taking too long. Your entries are retained. Retry the same save to check its result without creating another record.'));},20000);
 })]);}finally{if(timer)clearTimeout(timer)}
}
